import { type FallbackProps, ErrorBoundary } from "react-error-boundary";
import type { PropsWithChildren } from "react";
import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { sharedRequests } from "@/api/(requests)/shared";

export function RootErrorBoundary({ children }: PropsWithChildren<Record<string, unknown>>) {
  return (
    <ErrorBoundary FallbackComponent={RootFallback} onError={reportError}>
      {children}
    </ErrorBoundary>
  );
}

function RootFallback(_props: FallbackProps) {
  function handleReset() {
    // Full page reload clears React's error state — no need to call resetErrorBoundary()
    window.location.replace("/");
  }

  return (
    <main className="tw:flex tw:size-svw tw:items-center tw:justify-center">
      <div
        className="tw:flex tw:flex-col tw:items-center tw:gap-5 tw:text-center"
        style={{ maxWidth: 450 }}
      >
        <p className="tw:text-2xl tw:font-bold">The website experienced a problem.</p>
        <p className="tw:text-lg">
          Please try again. If the problem persists, please try again later. We apologize for the
          inconvenience.
        </p>

        <Button2 onPress={handleReset}>Return to home page</Button2>
      </div>
    </main>
  );
}

async function reportError(error: Error, info: React.ErrorInfo) {
  try {
    await sharedRequests.post_exception_report({
      context: {},
      report: {
        context: {
          error_component_stack: info.componentStack,
          error_message: error.message,
          error_name: error.name,
          original_error_stack: error.stack
            ?.replaceAll("http://", "")
            .replaceAll("https://", "")
            .replaceAll("localhost:3000", ""),
        },
        description: `${error.name} ${error.message}`,
        type: "frontend_error",
      },
    });
  } catch (e) {
    console.error("[RootErrorBoundary] failed to report error", e);
  }
}
